/* 🤖 this file was generated by svg-to-ts */
export const matIconFormatClear: {
  name: 'format-clear';
  data: string;
} = {
  name: 'format-clear',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 8V5H6.39l3 3h1.83l-.55 1.28 2.09 2.1L14.21 8zM3.41 4.86 2 6.27l6.97 6.97L6.5 19h3l1.57-3.66L16.73 21l1.41-1.41z"/></svg>`
};
